import request from "@/util/request";

export function Material_GetList(params) {
  return request({
    url: "/pc/Material/Material_GetList",
    method: "get",
    params,
  });
}
export function Material_GetClassifys(params) {
  return request({
    url: "/pc/Material/Material_GetClassifys",
    method: "get",
    params,
  });
}
export function Material_GetExts(params) {
  return request({
    url: "/pc/Material/Material_GetExts",
    method: "get",
    params,
  });
}
export function Material_GetDetail(params) {
  return request({
    url: "/pc/Material/Material_GetDetail",
    method: "get",
    params,
  });
}
export function Material_GetTeachers(params) {
  return request({
    url: "/pc/Material/Material_GetTeachers",
    method: "get",
    params,
  });
}
export function Material_GetRelatedMaterials(params) {
  return request({
    url: "/pc/Material/Material_GetRelatedMaterials",
    method: "get",
    params,
  });
}
export function MaterialID_GetDownUrl(params) {
  return request({
    url: "/pc/Material/MaterialID_GetDownUrl",
    method: "get",
    params,
  });
}
